import * as path from "path";
import { Agent } from "https";

import express, { Express } from "express";
import { createProxyMiddleware } from "http-proxy-middleware";

import { httpGet } from "../../Commons/HttpServer/AttributeRouting/Methods";
import { httpReturn } from "../../Commons/HttpServer/AttributeRouting/Results";
import {
    FileStreamResult,
    ProxyGetRequestToResult,
    StreamReturnResult,
} from "../../Commons/HttpServer/AttributeRouting/Results/StreamResultHandler";
import { SingletonController } from "../../Commons/HttpServer/ExpressWrapper/SingletonController";

export interface FormsTestingControllerOptions {
    frontEndDevMode: boolean;
    devServerUrl: string;
}

const defaultOptions: FormsTestingControllerOptions = {
    frontEndDevMode: false,
    devServerUrl: "https://localhost:8081",
};

export class FormsHelperController extends SingletonController {
    private readonly options: FormsTestingControllerOptions;

    public constructor(options: Partial<FormsTestingControllerOptions>) {
        super();
        this.options = {
            ...defaultOptions,
            ...options,
        };
    }

    public async setupMiddleware(expressApplication: Express): Promise<void> {
        if (this.options.frontEndDevMode) {
            expressApplication.use(
                [
                    "/forms-helper/*.js",
                    "/forms-helper/*.css",
                    "/forms-helper/*.map",
                    "/forms-helper/*.ico",
                    "/forms-helper/*.png",
                    "/forms-helper/*.json",
                ],
                createProxyMiddleware({
                    target: this.options.devServerUrl,
                    changeOrigin: true,
                    agent: new Agent({ rejectUnauthorized: false }),
                })
            );
        } else {
            expressApplication.use(
                "/forms-helper/",
                express.static(path.join(__dirname, "..", "..", "LocalServerFrontEndDist"))
            );
        }
    }

    @httpGet("/forms-helper", httpReturn.StreamWithMime("text/html"))
    public async getRunnerView(): Promise<StreamReturnResult> {
        if (this.options.frontEndDevMode) {
            return new ProxyGetRequestToResult(`${this.options.devServerUrl}/forms-helper/index.html`);
        } else {
            return new FileStreamResult(path.join(__dirname, "..", "..", "LocalServerFrontEndDist", "index.html"));
        }
    }
}
